import React from 'react';
import { List, Responsive, SimpleList, Datagrid, TextField } from 'react-admin';

export const MarketList = props => (
  <List {...props} bulkActionButtons={false}>
    <Responsive
      small={
        <SimpleList
          primaryText={record => record.name}
          secondaryText={record =>
            `${record.venue_name} ${record.venue_address}`
          }
          tertiaryText={record =>
            new Date(record.start_date).toLocaleDateString()
          }
        />
      }
      medium={
        <Datagrid>
          <TextField source="id" />
          <TextField source="short_name" />
          <TextField source="name" />
          <TextField source="min_capacity" />
        </Datagrid>
      }
    />
  </List>
);



// WEBPACK FOOTER //
// ./src/markets.js